import type { TodayLayoutItem } from '@scrambl/shared'

import { WIDGET_DEFINITIONS } from './widget-definitions'

/** Default priority only. Saved order is respected within each column. */
// Streak & goals sits right under My Work.
const WORK_FIRST = ['unified-inbox', 'my-tasks', 'engagement', 'action-center']
const CONTEXT_FIRST = ['todays-schedule', 'time-tracker', 'favorites']

export function getOverviewColumns(items: TodayLayoutItem[]) {
  const work: TodayLayoutItem[] = []
  const context: TodayLayoutItem[] = []
  for (const item of items) {
    if (item.hidden) continue
    const isContext = getOverviewColumn(item.id) === 'context'
    if (isContext) context.push(item)
    else work.push(item)
  }

  return { work, context }
}

export function getOverviewColumn(widgetId: string): 'work' | 'context' {
  const definition = WIDGET_DEFINITIONS.find(widget => widget.id === widgetId)
  return CONTEXT_FIRST.includes(widgetId) ||
    (definition?.columnType === 'sidebar' && !WORK_FIRST.includes(widgetId))
    ? 'context'
    : 'work'
}

export function prioritizeDefaultOverview(items: TodayLayoutItem[]) {
  const columns = getOverviewColumns(items)
  const prioritize = (column: TodayLayoutItem[], first: string[]) =>
    [...column].sort((a, b) => {
      const rank = (id: string) => {
        const index = first.indexOf(id)
        return index < 0 ? first.length : index
      }
      return rank(a.id) - rank(b.id)
    })

  return [
    ...prioritize(columns.work, WORK_FIRST),
    ...prioritize(columns.context, CONTEXT_FIRST),
  ]
}

export function getOverviewPresentation(value: unknown): 'focused' | 'grid' {
  return value === 'grid' ? 'grid' : 'focused'
}
